import type React from 'react';

import { Badge, Text } from '@change/ds-core-ui';
import { StarIcon } from '@change/ds-icons';

import { useI18n } from '@change-corgi/core/react/i18n';

import { Rectangle, SkeletonContainer } from 'src/app/pages/starterDashboardV2/shared/components';

import { SectionHeader } from '../SectionHeader';

const SKELETON_TASK_COUNT = 3;

const SkeletonTaskRow: React.FC<EmptyProps> = () => (
	<div className="flex items-center gap-5">
		<Rectangle className="h-6 w-6 shrink-0 rounded" />
		<Rectangle className="h-6 min-w-0 flex-1 rounded" />
		<Rectangle className="hidden h-9 w-44 shrink-0 rounded-lg md:block" />
		<Rectangle className="h-9 w-9 shrink-0 rounded-full" />
	</div>
);

export const DynamicTasksLoading: React.FC<EmptyProps> = () => {
	const { translate } = useI18n();

	return (
		<div className="bg-background-base flex flex-col gap-5 px-4 py-8 md:p-12" data-qa="dynamic-tasks-loading">
			<SectionHeader completed={0} total={0} />
			<SkeletonContainer loading shapeColorClassName="bg-background-overlay">
				<div className="flex flex-col gap-4">
					<div className="flex flex-col">
						{Array.from({ length: SKELETON_TASK_COUNT }, (_, i) => (
							<div
								key={i}
								className="border-stroke-weaker -mx-4 border-b border-solid px-4 py-5 first:border-t md:-mx-12 md:px-12"
							>
								<div className="flex flex-col gap-3">
									{i === 0 && (
										<Badge
											className="self-start"
											variant="information"
											emphasis="weaker"
											size="small"
											label={translate('corgi.petition.starter_dashboard_v2.dynamic_tasks.task.start_here_badge')}
											leadingIcon={<StarIcon className="text-icon-information !size-4" svgClassName="!size-4" />}
										/>
									)}
									<SkeletonTaskRow />
								</div>
							</div>
						))}
					</div>
					<Text variant="body" size="small" className="w-full text-center font-bold" as="p">
						{translate('corgi.petition.starter_dashboard_v2.dynamic_tasks.loading_text')}
					</Text>
				</div>
			</SkeletonContainer>
		</div>
	);
};
